module.exports = __webpack_public_path__ + "media/src/components/CancerInsurancePage/DefinitionSection/cancer-insurance-1d4322af54cb400666c14627d0acd09d.png";